import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaPrescriptionBottleAlt, FaMapMarkerAlt, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaClock, FaTablets } from 'react-icons/fa';
import Button from '../../components/Button';

const WebFarmaciaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Informa a tus pacientes 24/7",
      description: "Tu web trabaja todo el día, informando sobre horarios, servicios y guardias incluso cuando la farmacia está cerrada. Reduce llamadas y consultas básicas."
    },
    {
      title: "Destaca entre otras farmacias",
      description: "El 58% de las farmacias aún no tienen presencia online profesional. Diferénciate con una web que resalte tus servicios especializados y productos exclusivos."
    },
    {
      title: "Atrae clientes de tu zona",
      description: "El posicionamiento local permite que te encuentren cuando buscan 'farmacia cerca de mí' o 'farmacia en [tu barrio]'. Crucial para captar nuevos clientes."
    },
    {
      title: "Muestra tus servicios especiales",
      description: "Destaca servicios diferenciadores como nutrición, dermocosmética, formulación magistral o análisis clínicos. Aumenta el ticket medio mostrando servicios premium."
    },
    {
      title: "Información útil siempre actualizada",
      description: "Mantén a tus clientes informados sobre guardias, horarios especiales, nuevos servicios o promociones de temporada sin necesidad de cartelería física."
    },
    {
      title: "Retorno de inversión garantizado",
      description: "Con solo 3-4 nuevos clientes mensuales que lleguen por la web, recuperas la inversión en el primer trimestre. A partir de ahí todo son beneficios."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaPrescriptionBottleAlt />,
      title: "Catálogo de servicios profesionales",
      description: "Presentación visual de tus servicios farmacéuticos: formulación, nutrición, dermocosmética, análisis clínicos, etc. Texto SEO optimizado para cada especialidad."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño responsive multi-dispositivo",
      description: "El 74% de las búsquedas de farmacias se hacen desde el móvil. Tu web se adaptará perfectamente a cualquier tamaño de pantalla, mejorando la experiencia del usuario."
    },
    {
      icon: <FaClock />,
      title: "Información de guardias y horarios",
      description: "Sección dinámica y actualizable para mostrar guardias, horarios especiales y festivos. Reduce consultas telefónicas y mejora el servicio a tus pacientes."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización SEO local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Destaca cuando busquen farmacias cercanas con horarios e información actualizada."
    },
    {
      icon: <FaTablets />,
      title: "Promoción de productos exclusivos",
      description: "Sección para destacar productos exclusivos, novedades o promociones. Perfecto para impulsar ventas de productos específicos con alto margen."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para farmacias",
      description: "Posicionamiento para términos como 'farmacia en [tu zona]', 'servicios de nutrición farmacéutica' o 'análisis clínicos'. Orientado a tu público local."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para farmacias que necesitan una web sencilla pero profesional para comenzar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por farmacias. Equilibrio perfecto entre precio y funcionalidades para captar más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para farmacias que quieren destacar con más funcionalidades y mejor posicionamiento en el sector sanitario.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu farmacia, servicios especializados y necesidades. Planificamos una web que proyecte profesionalidad y conecte con tus pacientes.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño moderno y accesible, implementando las secciones clave para una farmacia: servicios, horarios, guardias, ubicación y contacto.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos para administrarla fácilmente y configuramos estrategias SEO local para captar pacientes de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para farmacias",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Calendario de guardias actualizable",
      us: true,
      others: false
    },
    {
      label: "Panel para gestionar horarios especiales",
      us: true,
      others: false
    },
    {
      label: "Cumplimiento normativas farmacéuticas",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Desde que lanzamos nuestra web, hemos notado un incremento significativo en clientes que buscan servicios especializados como nutrición y dermocosmética. La web nos permite destacar estos servicios que tienen mayor margen, en lugar de competir solo por precio. El calendario de guardias actualizable ha reducido drásticamente las llamadas para preguntar si estamos abiertos, y el posicionamiento local nos ha dado visibilidad frente a las grandes cadenas. Una inversión que se ha amortizado con creces.",
    author: "María Fernández",
    position: "Titular",
    company: "Farmacia San Bernardo",
    avatar: "/servicios/testimonios/farmacia.webp"
  };
  
  const founderMessage = "El sector farmacéutico está evolucionando hacia un modelo de servicios más allá de la dispensación. Las farmacias más exitosas son aquellas que digitalizan su comunicación, mostrando claramente sus servicios diferenciadores y facilitando información práctica como guardias y horarios especiales.";
  
  // FAQs específicas para web de farmacias
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi farmacia?",
      answer: "Una web profesional es indispensable para las farmacias modernas por varios motivos estratégicos: 1) El 72% de los pacientes buscan información sobre farmacias en internet antes de visitarlas; 2) Permite destacar tus servicios especializados y diferenciarte de la competencia; 3) Proporciona información esencial (horarios, guardias, ubicación) 24/7, reduciendo llamadas informativas; 4) Te posiciona en Google Maps y búsquedas locales, fundamental para captar nuevos clientes de proximidad; 5) Permite comunicar eficazmente servicios premium con mayor margen de beneficio; 6) Facilita la divulgación de consejos sanitarios, construyendo autoridad y confianza; 7) Complementa tus redes sociales con información estructurada y permanente. Según estudios del sector farmacéutico, las farmacias con presencia web profesional incrementan un 15-20% la afluencia de nuevos clientes y un 25% la demanda de servicios especializados de alto valor en el primer año.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrarán los servicios de mi farmacia en la web?",
      answer: "Tus servicios se presentarán de forma profesional y atractiva con estas características: 1) Organización por categorías (formulación magistral, nutrición, dermocosmética, análisis clínicos, etc.) para facilitar la navegación; 2) Páginas detalladas para cada servicio especializado, explicando beneficios, proceso y potenciales resultados; 3) Imágenes profesionales que transmitan confianza y profesionalidad; 4) Llamadas a la acción claras para consultar o reservar servicios; 5) Testimonios específicos para servicios premium; 6) Información sobre el equipo especializado y su formación; 7) Posibilidad de incluir vídeos explicativos para servicios complejos. Te proporcionaremos acceso a un panel intuitivo donde podrás actualizar descripciones, precios o añadir nuevos servicios. El enfoque será destacar especialmente aquellos servicios diferenciadores y con mayor margen, posicionándolos estratégicamente en la web para aumentar su demanda.",
      category: "Contenidos"
    },
    {
      question: "¿Es posible incluir un sistema de venta online en la web?",
      answer: "Sí, pero los sistemas de venta online para productos farmacéuticos no están incluidos en los precios base y se presupuestan aparte debido a su complejidad regulatoria: 1) Sistema básico de reserva de productos (desde 150€) - El cliente reserva productos para recoger en farmacia, sin pago online; 2) Sistema de venta online para productos no medicamentosos (desde 300€) - Plataforma completa con carrito, pasarela de pago y gestión de stock para parafarmacia; 3) Sistema completo para medicamentos sin receta (desde 500€) - Incluye verificaciones regulatorias, advertencias legales y cumplimiento normativo específico del sector farmacéutico. Estos sistemas son complementos opcionales que requieren configuración específica según tu modelo de negocio y los productos que desees comercializar. Es importante destacar que la venta online de medicamentos está estrictamente regulada, por lo que incluimos el asesoramiento legal específico para asegurar el cumplimiento de todas las normativas aplicables. El presupuesto exacto se determina tras analizar tus necesidades específicas y el marco legal aplicable.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas, adecuado para cada nivel de necesidad: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, servicios, horarios/guardias, ubicación y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, pudiendo añadir secciones como blog de consejos sanitarios, equipo profesional, formulación magistral, o páginas detalladas para servicios especializados; 3) El plan Premium (400€) permite entre 10-15 páginas, ampliando con contenido multiidioma, artículos especializados por áreas terapéuticas, o secciones específicas para cada línea de servicio. Si necesitas más páginas de las incluidas en tu plan, estas tienen un coste adicional de 40€ por página. Para webs realmente extensas con más de 15 páginas (como por ejemplo catálogos detallados de productos), recomendamos solicitar un presupuesto personalizado. La mayoría de farmacias obtienen excelentes resultados con el número de páginas incluido en los planes estándar, priorizando la calidad del contenido sobre la cantidad.",
      category: "Planes"
    },
    {
      question: "¿Cómo se gestionará la información de guardias y horarios especiales?",
      answer: "Implementamos un sistema intuitivo y fácil de usar para gestionar esta información crucial: 1) Panel de administración sencillo donde podrás actualizar horarios habituales, festivos y guardias con solo unos clics; 2) Calendario visual para programar guardias futuras o cambios de horario por festividades; 3) Opción de sincronización con Google Business Profile para que la información sea coherente en todos los canales; 4) Posibilidad de programar con antelación cambios temporales (ej. horario de verano); 5) Sección destacada en la página de inicio con la próxima guardia o información relevante de horarios; 6) Aviso automático de 'Abierto ahora' o 'Cerrado ahora' según el horario actual; 7) Notificaciones para recordarte actualizar información en fechas clave. Este sistema es especialmente valioso para farmacias, ya que reduce significativamente las llamadas preguntando por horarios o guardias (que según estudios del sector pueden suponer hasta el 40% de las llamadas recibidas). Durante la formación, dedicaremos tiempo específico para que domines esta funcionalidad esencial para tu gestión diaria.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye servicios esenciales para el correcto funcionamiento de tu web: 1) Alojamiento en servidores de alta velocidad y seguridad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL (fundamental para sitios relacionados con salud); 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento y seguridad. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar horarios, guardias, servicios, añadir entradas al blog de consejos sanitarios, y modificar información básica. Para farmacias, esto es especialmente útil por los frecuentes cambios de guardias y horarios especiales. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, la seguridad de los datos y el alojamiento seguro de los contenidos, especialmente importante en el ámbito sanitario.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para farmacias
      pageTitle="Web para Farmacias desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para farmacias. Información de guardias, servicios especializados y posicionamiento local para atraer más pacientes en tu zona."
      pageKeywords="página web barata farmacia, web para farmacias, diseño web farmacia, página web farmacia barata, web farmacia económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-farmacia"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para farmacias desde 200€ (informa y atrae clientes 24/7)"
      heroSubtitle="Diseño web profesional para farmacias. Muestra servicios, horarios, guardias y productos destacados. Optimizada para pacientes de tu zona."
      heroImage="/servicios/tipo-cliente/hero-farmacia.webp"
      badges={['Desde 200€ (pago único)', 'Servicios y guardias', 'Blog farmacéutico', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de farmacia"
      pricingSubtitle="Elige el plan que mejor se adapte a las necesidades de tu farmacia. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para farmacias?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de farmacia?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu farmacia"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para farmacias"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu farmacia con presencia online profesional"
      ctaDescription="Una inversión inteligente que informará a tus pacientes 24/7, destacará tus servicios especializados y atraerá nuevos clientes. Recupera la inversión en pocas semanas."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebFarmaciaPage; 

